import { useParams, useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useQuery } from 'react-query';
import { Box, Grid } from '@mui/material';
import CircularLoader from 'app/design/uiComponents/CircularLoader';
import PageHeader from 'app/design/speedBot/PageHeader';
import MarketplaceItems from 'app/design/itemsComponent/MarketplaceItems';
import { decodeUrlData } from 'utils/GenericFunctions';

// Service
import { GetMarketplaceBotsByCategory } from 'services/apiServices';
import {
  Errors,
  GetMarketplaceBotsByCategoryResult,
  TRA,
  TRABot,
} from 'types/ApiServicesTypes';
import Breadcrumbs from 'app/design/uiComponents/Breadcrumbs';
import { PAGES } from 'app/components/Common/Breadcrumb/types';
import RAHeadItem from './RAHeadItem';
import useGetResearchAnalysts from 'services/RABots/useGetResearchAnalysts';
import useGetResearchAnalystsDetails from 'services/RABots/useGetResearchAnalystsDetails';

const RAAuthor = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const { data, isLoading } = useGetResearchAnalystsDetails(parseInt(id));
  const author = data && data.data;
  const bots =
    author && author.ra_bots && author.ra_bots.length > 0
      ? author.ra_bots
      : null;

  return (
    <>
      <Helmet>
        <title>RA bots</title>
        <meta name="description" content="RA bots" />
      </Helmet>
      <CircularLoader open={isLoading} />
      <PageHeader
        variant="inactive"
        buttonText={''}
        title={''}
        buttonHandleClick={() => history.goBack()}
        breadcrumb={<Breadcrumbs page={PAGES.MARKETPLACE_CATEGORY} data={{}} />}
      />
      <Box
        sx={{
          mt: { xs: 1, md: 0 },
          mb: { xs: 0, md: 2 },
          display: { xs: 'block', md: 'block' },
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            flex: { md: 1, lg: 'initial' },
            width: '100%',
          }}
        >
          {author && (
            <RAHeadItem
              isSeeAll={false}
              fullWidth={true}
              category={author}
              isAuthorPage={true}
              handleClick={() => {
                //
              }}
            />
          )}
        </Box>
        <Box sx={{ flex: 1.5, justifyContent: 'end' }}>
          <Grid
            container
            spacing={0}
            sx={{
              maxWidth: { xs: 'initial', md: '32rem', lg: 'initial' },
              flex: { lg: 1, xl: 1 },
            }}
            className={''}
          >
            {bots && (
              <MarketplaceItems
                bots={bots}
                isGraph={true}
                isSearch={true}
                isRa={true}
                isAuthorPage={true}
              />
            )}
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default RAAuthor;
